import type { VercelRunner } from '@cli-types/next-adapter/vercel.js'
import { npxRunner } from './npx-runner.js'
import { pathRunner } from './path-runner.js'
import { runVercel } from './run-vercel.js'

export async function resolveVercelRunner(): Promise<VercelRunner> {
  const probe = await runVercel(pathRunner(), ['--version'], {
    cwd: process.cwd(),
    mode: 'capture',
    timeoutMs: 10_000
  })
  return probe.success ? pathRunner() : npxRunner()
}
